import React from 'react';
import { useTranslation } from 'react-i18next';
import { useTheme } from 'styled-components';
import { DepositFrequency } from '../../../../../utils/compound-interest/types';
import { cn } from '../../../../../utils/tailwind';
import { useCompoundInterestCalculatorContext } from '../../calculator-context/compound-interest-calculator-context';

interface CompoundInterestDepositFrequencyAdornmentProps {
    depositFrequency: DepositFrequency;
}

export const CompoundInterestDepositFrequencyAdornment: React.FC<CompoundInterestDepositFrequencyAdornmentProps> = ({
    depositFrequency,
}) => {
    const { t } = useTranslation();
    const theme = useTheme();
    const { handleDepositFrequencyChange } = useCompoundInterestCalculatorContext();

    const frequencyOptionClass = (isActive: boolean) =>
        cn(
            'cursor-pointer whitespace-nowrap rounded-[99rem] border-none px-[1.2rem] text-small font-bold transition-all duration-200',
            isActive
                ? 'bg-brand-primary text-text-inverse'
                : 'bg-transparent text-neutral-gray hover:bg-[var(--toggle-hover-bg)]',
        );

    return (
        <div className="flex items-center gap-[0.6rem]">
            <div
                className="flex h-[4rem] shrink-0 gap-[0.3rem] rounded-[99rem] p-[0.3rem]"
                style={{
                    background: theme.select.base.open.background,
                    ['--toggle-hover-bg' as string]: `${theme.palette.common.border}30`,
                }}
            >
                <button
                    type="button"
                    className={frequencyOptionClass(depositFrequency === 'monthly')}
                    onClick={() => handleDepositFrequencyChange('monthly')}
                >
                    {t('pages.compoundInterest.calculator.monthly')}
                </button>
                <button
                    type="button"
                    className={frequencyOptionClass(depositFrequency === 'weekly')}
                    onClick={() => handleDepositFrequencyChange('weekly')}
                >
                    {t('pages.compoundInterest.calculator.weekly')}
                </button>
            </div>
        </div>
    );
};
